import React from 'react';

/**
 * Logo FOGEDOM-SCIC
 * Fonds interne de la SCIC OBJECTIF SCOP OUTREMER
 * Inspiré du logo O'SCOP avec des couleurs représentant un fonds de garantie
 */
const LogoFogedomScic = ({ width = 300, height = 300, className = "" }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 300 300" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Fond circulaire avec dégradé */}
      <defs>
        {/* Dégradé pour le fond */}
        <radialGradient id="bgGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" style={{ stopColor: '#1e3a8a', stopOpacity: 0.1 }} />
          <stop offset="100%" style={{ stopColor: '#1e3a8a', stopOpacity: 0.05 }} />
        </radialGradient>
        
        {/* Dégradé pour les pétales - Or/Ambre (symbole de valeur/fonds) */}
        <linearGradient id="petalGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#f59e0b', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#d97706', stopOpacity: 1 }} />
        </linearGradient>
        
        {/* Dégradé Vert (sécurité/garantie) */}
        <linearGradient id="petalGreen" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#059669', stopOpacity: 1 }} />
        </linearGradient>
        
        {/* Dégradé Bleu foncé (solidité/fonds) */}
        <linearGradient id="petalBlue" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1e40af', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#1e3a8a', stopOpacity: 1 }} />
        </linearGradient>
        
        {/* Dégradé Cyan (innovation) */}
        <linearGradient id="petalCyan" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#06b6d4', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0891b2', stopOpacity: 1 }} />
        </linearGradient>
        
        {/* Ombre portée */}
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodOpacity="0.3"/>
        </filter>
      </defs>
      
      {/* Fond circulaire */}
      <circle cx="150" cy="150" r="140" fill="url(#bgGradient)" />
      
      {/* Centre du logo - Symbole de fonds (coffre-fort stylisé) */}
      <g transform="translate(150, 150)">
        {/* Cercle central - représente le fonds */}
        <circle cx="0" cy="0" r="35" fill="#1e3a8a" filter="url(#shadow)" />
        <circle cx="0" cy="0" r="30" fill="#2563eb" />
        
        {/* Symbole de protection - bouclier stylisé */}
        <path 
          d="M -12 -8 L 0 -15 L 12 -8 L 12 5 Q 12 12 0 15 Q -12 12 -12 5 Z"
          fill="white"
          opacity="0.9"
        />
        
        {/* Initiales F.G */}
        <text 
          x="0" 
          y="4" 
          textAnchor="middle" 
          fontSize="14" 
          fontWeight="bold" 
          fill="#1e3a8a"
          fontFamily="Arial, sans-serif"
        >
          F.G
        </text>
      </g>
      
      {/* Pétales symbolisant les garanties (4 pétales au lieu de 5) */}
      {/* Pétale Haut - Or (valeur du fonds) */}
      <ellipse 
        cx="150" 
        cy="65" 
        rx="35" 
        ry="50" 
        fill="url(#petalGold)"
        filter="url(#shadow)"
        transform="rotate(0 150 150)"
      />
      
      {/* Pétale Droite - Vert (garantie) */}
      <ellipse 
        cx="235" 
        cy="150" 
        rx="35" 
        ry="50" 
        fill="url(#petalGreen)"
        filter="url(#shadow)"
        transform="rotate(90 150 150)"
      />
      
      {/* Pétale Bas - Bleu (solidité) */}
      <ellipse 
        cx="150" 
        cy="235" 
        rx="35" 
        ry="50" 
        fill="url(#petalBlue)"
        filter="url(#shadow)"
        transform="rotate(180 150 150)"
      />
      
      {/* Pétale Gauche - Cyan (innovation) */}
      <ellipse 
        cx="65" 
        cy="150" 
        rx="35" 
        ry="50" 
        fill="url(#petalCyan)"
        filter="url(#shadow)"
        transform="rotate(270 150 150)"
      />
      
      {/* Texte autour - FOGEDOM */}
      <path 
        id="topPath" 
        d="M 50,150 A 100,100 0 0,1 250,150" 
        fill="none"
      />
      <text fontSize="28" fontWeight="bold" fill="#374151" fontFamily="Arial, sans-serif">
        <textPath href="#topPath" startOffset="50%" textAnchor="middle">
          FOGEDOM
        </textPath>
      </text>
      
      {/* Texte bas - SCIC */}
      <path 
        id="bottomPath" 
        d="M 250,150 A 100,100 0 0,1 50,150" 
        fill="none"
      />
      <text fontSize="24" fontWeight="600" fill="#6b7280" fontFamily="Arial, sans-serif">
        <textPath href="#bottomPath" startOffset="50%" textAnchor="middle">
          SCIC
        </textPath>
      </text>
      
      {/* Sous-titre - Fonds de Garantie */}
      <text 
        x="150" 
        y="280" 
        textAnchor="middle" 
        fontSize="12" 
        fill="#9ca3af"
        fontFamily="Arial, sans-serif"
        fontStyle="italic"
      >
        Fonds de Garantie Solidaire
      </text>
    </svg>
  );
};

export default LogoFogedomScic;
